import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { useTrackCallback } from '@/lib/analytics/events'

export const SettingsPage = () => {
  const trackSettingsView = useTrackCallback('settings.view')

  useEffect(() => {
    trackSettingsView({})
  }, [trackSettingsView])

  return (
    <div className='flex h-full min-h-0 w-full flex-1 flex-col overflow-y-auto'>
      <Outlet />
    </div>
  )
}
